import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoEditPen = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>EditPen</title>
    <path
      d="M20.05 8.95 7.835 21.165a1.333 1.333 0 0 0-.318.508l-1.691 4.896a.667.667 0 0 0 .848.848l4.896-1.692c.19-.066.364-.174.507-.317l12.214-12.213M20.049 8.95l2.537-2.537a2 2 0 0 1 2.828 0l1.414 1.414a2 2 0 0 1 0 2.829l-2.536 2.537M20.049 8.95l4.243 4.242"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default SvgIcoEditPen;
